/**
 * The address to put in the Email field when the page opens, taken from the
 * link's `email` parameter. The field stays editable; the value is used for
 * nothing else.
 */
export function prefillEmailFromSearch(search: string): string {
  const value = new URLSearchParams(search).get('email');
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * Which address the field starts with. On an invitation link the address the
 * link carries wins over one remembered from an earlier visit.
 */
export function initialSignUpEmail(
  search: string,
  remembered: string | null | undefined
): string {
  const params = new URLSearchParams(search);
  const fromLink = prefillEmailFromSearch(search);
  if (params.get('invite') && fromLink) return fromLink;
  if (typeof remembered === 'string' && remembered.trim()) return remembered;
  return fromLink;
}
